<template>
    <!-- iframe弹窗 -->
    <div class="new-popupbox" v-if="iframeUrl">
        <div class="hanlder-box">
            <svg class="icon-svg popup-close" @click="closeIframeBox">
                <use xlink:href="#icon-guanbi" />
            </svg>
        </div>
        <LoadingOutlined class="iframe-loading" />
        <iframe id="iframe-box" ref="iframeBox" class="box-content iframe-content" :src="iframeUrl" allowfullscreen="true"
            scrolling="no" frameborder="0" name="ifd" :style="{ backgroundColor: iframe_backcolor }"
            @load="listenIframeBox()"></iframe>
    </div>
</template>
<script>
import { LoadingOutlined } from "@ant-design/icons-vue";
export default {
    name: "CodeIframe",
    components: {
        LoadingOutlined
    },  
    props: {
        iframeUrl: String
    },
    data() {
        return {
            iframe_backcolor: '#ffffff00',
            userInfo: null
        }
    },
    mounted() {
        let { userInfo } = this.$store.state;
        this.userInfo = userInfo;
    },
    methods: {
        //监听iframe弹窗
        listenIframeBox() {
            let that = this;
            this.$nextTick(() => {
                let iframe = that.$refs["iframeBox"];
                //发送值
                iframe.contentWindow.postMessage({
                    command: 'postStudentId',
                    data: {
                        studentId: this.userInfo.PK_UserGuid,
                    },
                }, '*')
            })
        },
        closeIframeBox() {
            this.$emit('closeIframeBox');
        }
    }
}
</script>